import { useCallback, useEffect, useRef, useState } from 'react';
import { Question } from './useConversationalOnboarding.ts';

interface UseSummaryModeOptions {
  currentQuestion: Question | null;
  onExitComplete: () => void;
}

export const useSummaryMode = ({ currentQuestion, onExitComplete }: UseSummaryModeOptions) => {
  const [summaryModeActive, setSummaryModeActive] = useState(false);
  const pendingSummaryModeRef = useRef(false);
  const prevQuestionIdRef = useRef<string | null>(null);
  const wasSummaryRef = useRef(false);
  const wideLayoutRef = useRef(false);
  const isSummaryQuestion = currentQuestion?.type === 'interactive' && currentQuestion?.interactiveType === 'summary';
  const isWideLayoutQuestion =
    currentQuestion?.type === 'interactive' && currentQuestion?.interactiveType === 'summary';
  wideLayoutRef.current = !!isWideLayoutQuestion;

  useEffect(() => {
    const prevId = prevQuestionIdRef.current;
    const nextId = currentQuestion?.id ?? null;

    if (isWideLayoutQuestion) {
      if (prevId && prevId !== nextId) {
        pendingSummaryModeRef.current = true;
        setSummaryModeActive(false);
      } else {
        pendingSummaryModeRef.current = false;
        setSummaryModeActive(true);
      }
    } else if (wasSummaryRef.current) {
      pendingSummaryModeRef.current = true;
      setSummaryModeActive(true);
    } else {
      pendingSummaryModeRef.current = false;
      setSummaryModeActive(false);
    }

    prevQuestionIdRef.current = nextId;
    wasSummaryRef.current = isWideLayoutQuestion;
  }, [isWideLayoutQuestion, currentQuestion?.id]);

  const handleSummaryExitComplete = useCallback(() => {
    onExitComplete();
    if (pendingSummaryModeRef.current) {
      pendingSummaryModeRef.current = false;
      setSummaryModeActive(wideLayoutRef.current);
    }
  }, [onExitComplete]);

  return {
    summaryModeActive,
    isSummaryQuestion,
    handleSummaryExitComplete,
  };
};
